<template>
  <mdb-navbar-nav >
    <mdb-nav-item :to="{name: 'Home'}" href="/" icon="home">Home</mdb-nav-item>
    <mdb-nav-item :to="{name: 'TrainingIntro'}" icon="landmark">훈련소개</mdb-nav-item>
    <mdb-nav-item :to="{name: 'StudentTestSummaryPage'}" icon="highlighter">평가</mdb-nav-item>
    <mdb-nav-item :to="{name: 'StudentBoardPage'}" icon="clipboard-list">게시판</mdb-nav-item>
  </mdb-navbar-nav>
</template>
<script>
import { mdbNavbarNav, mdbNavItem } from 'mdbvue';
export default {
  name: 'StudentMenu',
  components: { mdbNavbarNav, mdbNavItem }
}
</script>
